import { render, staticRenderFns } from "./GroupGreeter.vue?vue&type=template&id=dd144914&"
import script from "./GroupGreeter.vue?vue&type=script&lang=js&"
export * from "./GroupGreeter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports